export const ONE_SIGNAL_ICON_CONTAINER_ID = 'onesignal-bell-container'
export const SHOW_ONE_SIGNAL_ICON_BUS_NAME = 'show-one-signal-icon'

export const ONE_SIGNAL_CATEGORY_INTEREST_STORAGE_KEY =
  'onesignal_category_interest_v1'
